var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"resume-request-btn",attrs:{"variant":_vm.variant,"disabled":_vm.disabled,"title":_vm.lockedReason,"size":"sm"},on:{"click":function($event){$event.stopPropagation();return _vm.onClick.apply(null, arguments)}}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }